import React from 'react'
import { string, arrayOf, shape } from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { logoWhite, sloganWhite } from '@assets'

import Image from '@components/Image'

import getCurrentYear from '@client/utils/date'

import * as FooterStyle from './Footer.style'

export default function Footer({ social, company, links }) {
  return (
    <>
      <FooterStyle.Main>
        <FooterStyle.Container>
          <FooterStyle.Box>
            {links && (
              <FooterStyle.Links>
                {links.map(({ url, label }) => (
                  <FooterStyle.LinkItem key={label} href={url}>
                    <FormattedMessage id={label} />
                  </FooterStyle.LinkItem>
                ))}
              </FooterStyle.Links>
            )}

            {social && (
              <FooterStyle.Social>
                {social.map(({ url, icon, alt }) => (
                  <a key={url} href={url}>
                    <FooterStyle.SocialIcon src={icon} alt={alt} />
                  </a>
                ))}
              </FooterStyle.Social>
            )}

            <FooterStyle.Logos>
              <Image src={logoWhite} alt="Gympass written in white letters" />
              <Image
                src={sloganWhite}
                alt='The gympass slogan "helping people find an activity to love" written in white letter with helping people in bold font'
              />
            </FooterStyle.Logos>
          </FooterStyle.Box>
        </FooterStyle.Container>
      </FooterStyle.Main>

      <FooterStyle.Rights>
        <FooterStyle.Container>
          <FooterStyle.Box>
            <FooterStyle.ReCaptchaRights>
              <FormattedMessage id="smb_acquisition_footer.recaptcha" />
            </FooterStyle.ReCaptchaRights>

            <FooterStyle.GympassRights>
              &copy; 2012-{getCurrentYear()} {company}. -{' '}
              <FormattedMessage id="smb_acquisition_footer.rights" />
            </FooterStyle.GympassRights>
          </FooterStyle.Box>
        </FooterStyle.Container>
      </FooterStyle.Rights>
    </>
  )
}

Footer.propTypes = {
  company: string,
  social: arrayOf(
    shape({
      url: string,
      label: string,
    })
  ),
  links: arrayOf(
    shape({
      url: string,
      icon: string,
      alt: string,
    })
  ),
}

Footer.defaultProps = {
  company: 'GPBR Part. Ltda.',
  social: null,
  links: null,
}
